import { ViewModel,View, ObservableArray, Component } from "binder"
import  { PieChartView } from "./pieChart-view"

export class PieChartViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.legend = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new PieChartView();
    }
    public getTypeId(): string {
        return "VM-A1286FFE-DABC-4178-868D-4CD4E2A0AD3A"
    }

    public set chartdata(v: ObservableArray<chartData>) { this._chartdata = v; } public get chartdata(): ObservableArray<chartData> { return this._chartdata;} private _chartdata: ObservableArray<chartData>;
    public set legend(v: boolean) { this._legend = v; } public get legend(): boolean { return this._legend;} private _legend: boolean;
    
}

export class chartData extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,name:string,amount:number,tooltip?:string) {
        super(parent);
        this.name = name;
        this.amount = amount;
        if(tooltip==null)
            tooltip = '';
        this.tooltip = tooltip;
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set tooltip(v: string) { this._tooltip = v; } public get tooltip(): string { return this._tooltip;} private _tooltip: string;
}